__turbopack_context__.v({
  "avatar": "styles-module-scss-module__p6lrIa__avatar",
  "backButton": "styles-module-scss-module__p6lrIa__backButton",
  "header": "styles-module-scss-module__p6lrIa__header",
  "iconArrow": "styles-module-scss-module__p6lrIa__iconArrow",
  "title": "styles-module-scss-module__p6lrIa__title",
});
